__turbopack_context__.v({
  "content": "VideoPromoKentico-module__sczphq__content",
  "cta": "VideoPromoKentico-module__sczphq__cta",
  "layout": "VideoPromoKentico-module__sczphq__layout",
  "playIcon": "VideoPromoKentico-module__sczphq__playIcon",
  "text": "VideoPromoKentico-module__sczphq__text",
  "thumbnail": "VideoPromoKentico-module__sczphq__thumbnail",
  "title": "VideoPromoKentico-module__sczphq__title",
  "video": "VideoPromoKentico-module__sczphq__video",
});
